package com.essntl.features.authentication.ui.auth

sealed interface AuthEvent {
    data class UpdateAuthFields(val state: AuthState) : AuthEvent

    data object UpdateEmailError : AuthEvent
    data object CheckEmail : AuthEvent

    data object Register : AuthEvent
    data object ClearRegister : AuthEvent

    data object Login : AuthEvent
    data object Clear : AuthEvent

    data object Back : AuthEvent
}